/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgentAccessQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentAccessQuery = { agentAccess: { __typename: 'AgentAccess', enabled: boolean, speech: boolean } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };


export const AgentAccessDocument = gql`
    query AgentAccess {
  agentAccess {
    __typename
    ... on AgentAccess {
      enabled
      speech
    }
  }
}
    `;

/**
 * __useAgentAccessQuery__
 *
 * To run a query within a React component, call `useAgentAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentAccessQuery(baseOptions?: Apollo.QueryHookOptions<AgentAccessQuery, AgentAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentAccessQuery, AgentAccessQueryVariables>(AgentAccessDocument, options);
      }
export function useAgentAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentAccessQuery, AgentAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentAccessQuery, AgentAccessQueryVariables>(AgentAccessDocument, options);
        }
export function useAgentAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentAccessQuery, AgentAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentAccessQuery, AgentAccessQueryVariables>(AgentAccessDocument, options);
        }
export type AgentAccessQueryHookResult = ReturnType<typeof useAgentAccessQuery>;
export type AgentAccessLazyQueryHookResult = ReturnType<typeof useAgentAccessLazyQuery>;
export type AgentAccessSuspenseQueryHookResult = ReturnType<typeof useAgentAccessSuspenseQuery>;
export type AgentAccessQueryResult = Apollo.QueryResult<AgentAccessQuery, AgentAccessQueryVariables>;